import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/app/components/ui/tooltip';
import { Flex } from '@radix-ui/themes';

interface HighestBidToolTipProps {
  children: React.ReactNode;
  className?: string;
}

const HighestBidToolTip = ({
  children,
  className
}: HighestBidToolTipProps) => {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger className={`${className} w-full`} asChild>
          <Flex className='w-full flex-1'>
            <div className="cursor-pointer w-full">
              {children}
            </div>
          </Flex>
        </TooltipTrigger>
        <TooltipContent>
          You have the highest bid on this lot.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default HighestBidToolTip;
